import { CONTACT } from "@/data/site";

export function whatsappUrl(message) {
  const base = `https://wa.me/${CONTACT.whatsappNumber}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}

export function telUrl() {
  return `tel:${CONTACT.phoneTel}`;
}

export const DEFAULT_WA_MESSAGE =
  "Olá! Preciso de um guincho / auto socorro da Auto Socorro Pimenta. Pode me atender?";

export function buildQuoteMessage({ name, city, vehicle, service, details }) {
  const lines = [
    "*Solicitação de Guincho — Auto Socorro Pimenta*",
    name && `Nome: ${name}`,
    city && `Localização: ${city}`,
    service && `Serviço: ${service}`,
    vehicle && `Veículo: ${vehicle}`,
    details && `Detalhes: ${details}`,
  ].filter(Boolean);
  return lines.join("\n");
}
